import { toDate as a } from "./toDate.js";
function n(t) {
  return a(t).getDay();
}
export {
  n as default,
  n as getDay
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getDay.js
// module id = 1385
// module chunks = 67